module.exports = __webpack_public_path__ + "img/icon6.7cd538df.png";